export const accountScopingColumns = ['_cdc_hash', '_cdc_seq', 'r1_id', 'day', 'in_scope', 'log'];
